/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectManagementWizard/emailAttachments/interfaces"/>
import { ExtensionsTypeLookup, UploadProgressEnum } from "@medius/ui-controls";

export interface IAttachmentItem {
    id: string;
    file: File;
    status: UploadProgressEnum;
    error?: string;
    addedAtTimestamp: number;
}

export interface IInvoiceImageDto {
    name: string;
    hash: string;
    fileSize: number;
}

// the same as for uploading attachment on the invoice
export const supportedExtensions = [
    ExtensionsTypeLookup.csv,
    ExtensionsTypeLookup.doc,
    ExtensionsTypeLookup.docx,
    ExtensionsTypeLookup.gif,
    ExtensionsTypeLookup.jpegAll,
    ExtensionsTypeLookup.json,
    ExtensionsTypeLookup.msg,
    ExtensionsTypeLookup.pdf,
    ExtensionsTypeLookup.png,
    ExtensionsTypeLookup.ppt,
    ExtensionsTypeLookup.pptx,
    ExtensionsTypeLookup.ods,
    ExtensionsTypeLookup.txt,
    ExtensionsTypeLookup.xls,
    ExtensionsTypeLookup.xlsx,
    ExtensionsTypeLookup.xml,
    ExtensionsTypeLookup.zip,
    "application/octet-stream",
    "application/oxps",
    "application/postscript",
    "application/rtf",
    "application/vnd.etsi.asic-e+zip",
    "application/vnd.ms-excel",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
    "application/vnd.ms-excel.sheet.macroEnabled.12",
    "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
    "application/vnd.ms-word.document.macroEnabled.12",
    "application/vnd.ms-xpsdocument",
    "application/vnd.oasis.opendocument.text",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
    "application/x-7z-compressed",
    "application/xslt+xml",
    "image/bmp",
    "image/svg+xml",
    "image/tiff",
    "image/vnd.dxf",
    "message/rfc822",
    "text/html"
];